import React, { useEffect, useState }                   from 'react';
import { useDispatch, useSelector }                     from 'react-redux';
import { Spinner }                                      from 'react-bootstrap';

import AuthoritiesService                               from '../../../services/AuthoritiesService';
import TableList                                        from '../../layout/TableList';
import QuickFilter                                      from '../../layout/QuickFilter';

import { ACTION_EDIT, ACTION_DELETE }                   from '../../extras/actionTypes';
import { ConfirmDeleteMessage }                         from '../../extras/toastMessages';
import { deleteAudienceMotivesAction }                  from '../../../actions/audienceMotivesActions';
import { editAudienceMotivesAction }                    from '../../../actions/audienceMotivesActions';
import { listAudienceMotivesAction }                    from '../../../actions/audienceMotivesActions';
import { MSG_DELETE, MSG_NOT_REVERT_OPERATION }         from '../../../constants/messages';
import { PARAMETROS_ELIMINAR, PARAMETROS_MODIFICAR }    from '../../../data/objects';



const AudienceMotiveList = props => {


    // --------------------------------------------------------------------------------------------
    // DECLARACIONES ------------------------------------------------------------------------------
    // --------------------------------------------------------------------------------------------

    const params = {
        sort: 'descripcion:asc'
    }

    // Tomo los props
    const { handleOpen, handleClose } = props;

    // Inicializo el dispatch
    const dispatch = useDispatch();

    // Traigo el store de persona tipos
    const audienceMotives = useSelector( state => state.audienceMotives.audienceMotives );
    const audienceMotivesLoading = useSelector( state => state.audienceMotives.loading );
    const authorities = useSelector(state => state.auth.authorities);
    
    // Inicializo el state local
    const [ data, setData ] = useState(null);    


    // --------------------------------------------------------------------------------------------
    // FUNCIONES ----------------------------------------------------------------------------------
    // --------------------------------------------------------------------------------------------
    
    // Manjo la eliminación
    const handleDelete = item => {
        //Confirmación
        ConfirmDeleteMessage(
            MSG_DELETE,
            MSG_NOT_REVERT_OPERATION,
            () => {
                dispatch( deleteAudienceMotivesAction(item) )
            }
        )
    }
    
    // Manejo de la edición
    const handleEdit = item => {
        //Llamo al dispatch de edición
        dispatch( editAudienceMotivesAction(item, handleOpen) );
    } 

    //Inicializo las cabeceras
    const headers = [
        {   name: 'Descripción',
            width: null,
            style: null,
            field: 'descripcion'
        },
        {   name: 'Grupo',
            width: null,
            style: 'text-center',
            field: 'grupo',
        },
        {   name: 'Acción',
            width: '10%',
            style: 'text-center',
            actions: [
                {   name: ACTION_EDIT,
                    handle: handleEdit,
                    granted: authorities && AuthoritiesService.hasPermission(authorities, PARAMETROS_MODIFICAR)
                },
                {   name: ACTION_DELETE,
                    handle: handleDelete,
                    granted: authorities && AuthoritiesService.hasPermission(authorities, PARAMETROS_ELIMINAR)
                }
            ]
        }
    ];
    
    // Cargo los datos
    useEffect(() => {
        //Verifico si hay datos
        if(audienceMotives)
        {   //Seteo los datos
            setData(audienceMotives);
        }
        else
        {   //Si no hay datos, debo cargarlo
            dispatch( listAudienceMotivesAction(params) );
        }
        //eslint-disable-next-line
    }, [audienceMotives]);


    
    // --------------------------------------------------------------------------------------------
    // RENDERIZO ----------------------------------------------------------------------------------
    // --------------------------------------------------------------------------------------------

    return (
        <div className="row">
            <div className="col-12">
                <div className="card shadow mb-4">
                    <div className="card-header py-3">
                    <h6 className="m-0 font-weight-bold text-primary">Listado</h6>
                    </div>
                    <div className="card-body">
                        <QuickFilter
                            headers = { headers }
                            initialData = { audienceMotives }
                            setData = { setData }
                        />

                        {   audienceMotivesLoading 
                                ?
                                    <Spinner animation="border" role="status">
                                        <span className="sr-only">Cargando...</span>
                                    </Spinner>
                                : 
                                    null
                        }

                        {   data 
                                ?
                                    <TableList
                                        headers = { headers }
                                        items = { data }
                                        prefix = "am"
                                        state = {{
                                            field: 'activo',
                                            disabledClass: 'table-danger',
                                            disabledValue: 0,
                                            hideActions: true
                                        }}
                                    />
                                : 
                                    null
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AudienceMotiveList;
